
import { SnackbarProvider } from 'notistack';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ScrollToTop } from './Hooks/usePreventScrolling';
import { useDispatch } from 'react-redux';
import { setUserData } from './redux-store/auth/actions';
import backend from './api';

import './App.css'



// User Dashboard pages
import UserDashboardMainLayout from './Panels/UserDashboard/MainLayout/MainLayout';
import UserDashboardDashboard from './Panels/UserDashboard/Pages/Activity/Dashboard/Dashboard';
import UserDashboardReports from './Panels/UserDashboard/Pages/Activity/Reports/Reports';
import UserDashboardUpgrades from './Panels/UserDashboard/Pages/MoreFeatures/Upgrades/Upgrades';
import UserDashboardSettings from './Panels/UserDashboard/Pages/Setup/Settings/Settings';

import Home from './MainWebsite/Pages/Home/Home';
import Footer from './MainWebsite/GlobalComp/Footer/Footer';
import Signup from './MainWebsite/Pages/Signup/Signup';
import Auth from './MainWebsite/Pages/Auth/Auth';
import ViewReport from './Panels/UserDashboard/Pages/Activity/Reports/ViewReport/ViewReport';
import UserDashboardInformation from './Panels/UserDashboard/Pages/Setup/Information/Information';
import ContactUs from './MainWebsite/Pages/ContactUs/ContactUs';
import DataPolicy from './MainWebsite/Pages/DataPolicy/DataPolicy';
import TermsOfService from './MainWebsite/Pages/TermsOfService/TermsOfService';
import PrivacyPolicy from './MainWebsite/Pages/PrivacyPolicy/PrivacyPolicy';

const UserDashboardWithSideBar = (Component) => (
  <UserDashboardMainLayout component={<Component />} />
);

const UserDashboardLoggedInRoutes = () => (
  <Routes>
    <Route path="/" element={UserDashboardWithSideBar(UserDashboardDashboard)} />
    <Route path="/reports" element={UserDashboardWithSideBar(UserDashboardReports)} />
    <Route path="/report/:id" element={UserDashboardWithSideBar(ViewReport)} />
    <Route path="/information" element={UserDashboardWithSideBar(UserDashboardInformation)} />
    <Route path="/settings/:profile" element={UserDashboardWithSideBar(UserDashboardSettings)} />
    <Route path="/upgrade" element={UserDashboardWithSideBar(UserDashboardUpgrades)} />

    <Route path='/contact-us' element={<ContactUs />} />

    <Route path="*" element={UserDashboardWithSideBar(UserDashboardDashboard)} />
  </Routes>
);

const RenderRouterWithMenuFooter = (Component) => (
  <>
    <Component />
  </>
);

const MainWebsiteLoggedOutRoutes = () => (
  <>
    <Routes>
      <Route path='/' element={RenderRouterWithMenuFooter(Home)} ></Route>
      <Route path='/signup' element={<Signup />} />
      <Route path='/login' element={<Auth />} />
      <Route path='/contact-us' element={<ContactUs />} />
      <Route path='/data-security' element={<DataPolicy />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/terms-of-service' element={<TermsOfService />} />

      <Route path='*' element={RenderRouterWithMenuFooter(Home)} ></Route>
    </Routes>
  </>
)

function AppRoutes() {

  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user) {
      const userId = user?._id;
      const fetchUser = async () => {
        const res = await backend.put(`/api/user/${userId}`);
        const updated = { ...user, ...res.data.data };
        await dispatch(setUserData(updated));
      }
      fetchUser();
    }
  }, [])

  return (
    <>
      <BrowserRouter>
        <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
          <ScrollToTop />
          {user ?
            <UserDashboardLoggedInRoutes /> : <MainWebsiteLoggedOutRoutes />}
          {/* <MainWebsiteLoggedOutRoutes /> */}
        </SnackbarProvider>
      </BrowserRouter>
    </>
  );
}

export default AppRoutes;
